"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmptyLookState;
const react_1 = __importDefault(require("react"));
const PrimaryButton_1 = require("../Button/PrimaryButton");
const EmptyStateBasePage_1 = require("./EmptyStateBasePage");
function EmptyLookState({ showCreateButton = false, t }) {
    const body = t('emptyLookText', { ns: 'EmptyState' });
    return (react_1.default.createElement(EmptyStateBasePage_1.EmptyStateBasePage, { body: body, imgSrc: "/images/empty-state-look.svg" }, showCreateButton && (react_1.default.createElement(PrimaryButton_1.PrimaryButton, { text: t('createLookButton', { ns: 'translation' }), ariaLabel: t('createLookButton', { ns: 'translation' }), id: "createButton" }))));
}
